import { Bot } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

interface CopilotTriggerProps {
  onClick: () => void;
  isOpen: boolean;
}

export function CopilotTrigger({ onClick, isOpen }: CopilotTriggerProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          onClick={onClick}
          variant={isOpen ? "secondary" : "ghost"}
          size="icon"
          className="h-8 w-8"
        >
          <Bot className="w-4 h-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom">
        <p className="font-mono text-xs">{isOpen ? "Close Copilot" : "Brickshare Copilot"}</p>
      </TooltipContent>
    </Tooltip>
  );
}
